import { createSession } from '@platform/ui';
import { api, type Session } from './api';

/** Webmail session (identity of the signed-in user for this tab). */
export const { SessionProvider: AuthProvider, useSession: useAuth } = createSession<Session>(api);
